export const SUMMARY_TYPE = 'summary';
export const SELECT_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
export const MULTI_CHECKBOXES_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
export const USER_CF_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
